import React from 'react'
import ReactGA from 'react-ga'
import { Router, Route, Link, browserHistory } from 'react-router'
import { connect } from 'react-redux'
import { setUsername } from '../actions/users'
import { setGameList, openChallengeModal, openAlertModal, setFriendList } from '../actions/layout'
import Landing from '../containers/Landing'
import CoreLayout from '../containers/CoreLayout'
import Homepage from '../containers/Homepage/Homepage'
import GameList from '../components/GameList/GameList'
import Rules from '../components/Rules'
import Game from '../components/Game/Game'
// import MultiGame from '../components/Game/MultiGame'
// import Challenges from '../components/Challenges/Challenges'
import Login from '../components/Users/Login'
import Profile from '../components/Users/Profile'
import Register from '../components/Users/Register'
import Finalize from '../components/Users/Finalize'
import Verify from '../components/Users/Verify'
import LeaderboardsList from '../components/Leaderboards/LeaderboardsList'
import FriendsList from '../components/Friends/FriendsList'
import Company from '../containers/Company/company'
import Privacy from '../containers/Privacy/privacy'
import Mobile from '../containers/Mobile/mobile'

ReactGA.initialize('UA-82499124-1')

const logPageView = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
}

class App extends React.Component {

  componentWillMount () {
    const { messaging, openAlertModal } = this.props

    messaging.onMessage(payload => {
      const notificationInfo = payload.notification
      if (notificationInfo) {
        const { title, icon, body, click_action } = notificationInfo
        if (body.includes('finished') && window.location.pathname.includes('game')) { return }
        if (this.isMobile()) {
          return openAlertModal(body)
        }
        const notification = new Notification(title, { icon, body })
        notification.addEventListener('click', () => {
          if (window.location.href != click_action) {
            window.location.href = click_action
          }
          notification.close()
        })
      }
    })
  }

  isMobile () {
    return /Android/i.test(navigator.userAgent)
      ||  /BlackBerry/i.test(navigator.userAgent)
      || /iPhone|iPad|iPod/i.test(navigator.userAgent)
      || /IEMobile/i.test(navigator.userAgent)
  }

  render () {
    const { setGameList, setFriendList, openChallengeModal, messaging } = this.props

    return(
      <Router history={browserHistory} onUpdate={logPageView}>
        <Route path='/' component={Landing} />
        <Route path='/home' component={Homepage} />
        <Route path='/main' component={CoreLayout}>
          <Route path='/rules' component={Rules} />
          <Route path='/list_solo' component={GameList} onEnter={() => setGameList('solo')} />
          <Route path='/list_versus' component={GameList} onEnter={() => setGameList('versus')} />
          <Route path='/challenges' component={GameList} onEnter={() => setGameList('challenges')} />
          <Route path='/challenges/new' component={GameList} onEnter={() => setGameList('challenges') && openChallengeModal() } />
          <Route path='/game' component={Game} />
          <Route path='/game/:gameId' component={Game} />
          <Route path='/leaderboards' component={LeaderboardsList} />
          <Route path='/login' component={Login} />
          <Route path='/register' component={Register} />
          <Route path='/finalize' component={Finalize} />
          <Route path='/profile' component={Profile} />
          <Route path='/profile/:username' component={Profile} />
          <Route path='/friends' component={FriendsList} onEnter={() => setFriendList('friends')} />
          <Route path='/friends/new' component={FriendsList} onEnter={() => setFriendList('add_new')} />
        </Route>
        <Route path='/users/:username/verify/:verifyCode' component={Verify} />
        <Route path='/company' component={Company} />
        <Route path='/nomostudios' component={Company} />
        <Route path='/privacy' component={Privacy} />
        <Route path='/mobile' component={Mobile} />
      </Router>
    )
  }
}

export const mapStateToProps = (state: any, ownProps: any): any => {
  return {
  }
}

export const mapDispatchToProps = (dispatch: Function, ownProps: any): any => {
  return {
    openAlertModal: (msg) => dispatch(openAlertModal(msg)),
    setGameList: (view) => dispatch(setGameList(view)),
    openChallengeModal: () => dispatch(openChallengeModal()),
    setFriendList: (list) => dispatch(setFriendList(list)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



/** WEBPACK FOOTER **
 ** ./src/components/app.js
 **/